// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7LY23","col":"styles_col__1mjdy"};